'use strict'

document.addEventListener("DOMContentLoaded", function(event) {
    /********************************
     * Menu
     *******************************/
    const body = document.querySelector('body');
    const mask = document.querySelector('.mask');

    (() =>{
        const triggerMenu = document.querySelector('.menu-btn');

        triggerMenu.addEventListener('click', () => {
            if(body.classList.contains('show-search')){
                body.classList.remove('show-search');
            }

            body.classList.toggle('show-menu')
        });

        mask.addEventListener('click', () => body.classList.remove('show-menu'));
    })();


    /********************************
     * Mobile Menu
     *******************************/
    const mobileMenuWrapper = document.querySelector('.header-menu-list');

    if(mobileMenuWrapper && window.innerWidth <= 991){
        const mobileMenu = (target, itemActive) => {
            const menuItem = target.closest('.navigation-item');
            const subMenu = menuItem.querySelector('.navigation-list');

            if(menuItem.classList.contains('active')){
                menuItem.classList.remove('active');
                subMenu.style.height = 0 + 'px';
            }else{
                if(itemActive){
                    itemActive.classList.remove('active');
                    itemActive.querySelector('.navigation-list').style.height = 0 + 'px';
                }
                menuItem.classList.add('active');
                subMenu.style.height = (subMenu.scrollHeight + 22) + "px";
            }
        }

        mobileMenuWrapper.addEventListener('click', function ({target}){
            const itemActive = document.querySelector('.navigation-item.active');

            if(target.closest('.products-link')){
                const elementParent = target.closest('.products-link');
                console.log(elementParent.querySelector('a'))
                elementParent.querySelector('a').removeAttribute('href');
                mobileMenu(target, itemActive);
            }

            if(target.closest('.icon-wrapper')){
                mobileMenu(target, itemActive);
            }
        });
    }

    /********************************
     * Check annotate bar
     *******************************/
    (() =>{
        const annotateBar = document.querySelector('#section-announcement');
        const header = document.querySelector('.header');
        const fakePadding = document.querySelector('.fake-padding');

        if(annotateBar){
            let getOffsetHeightBar = annotateBar.offsetHeight;
            const headerHeight = header.offsetHeight;

            header.classList.add('isAnnotateBar');
            header.style.top = `${getOffsetHeightBar}px`;

            if(body.getAttribute('data-route') !== 'index'){
                fakePadding.style.paddingTop = `${getOffsetHeightBar + headerHeight}px`;
            }

            window.addEventListener('scroll', () =>{
                if(window.scrollY > getOffsetHeightBar){
                    header.style.top = `0px`;
                } else{
                    header.style.top = `${getOffsetHeightBar}px`;
                }
            });

            window.addEventListener('resize', () =>{
                getOffsetHeightBar = annotateBar.offsetHeight;

                if(window.scrollY > getOffsetHeightBar){
                    header.style.top = `0px`;
                } else{
                    header.style.top = `${getOffsetHeightBar}px`;
                }
            });
        }

    })();

    /********************************
     * Scroll header
     *******************************/
    window.addEventListener('scroll', function() {
        window.scrollY > 0
            ? body.classList.add('header-scroll')
            : body.classList.remove('header-scroll')
    })


    /********************************
     * Scroll To Page
     *******************************/
    const scrollToSection = document.querySelector('.scroll-to-page');

    if(scrollToSection){
        scrollToSection.addEventListener('click', (event)=>{
            event.preventDefault();
            const target = event.target;

            if(target.closest('.navigation-toggle')){
                const getSectionScroll = target.getAttribute('data-scroll-section');
                localStorage.setItem('sectionScroll', getSectionScroll);
                location.href = target.getAttribute('href');
            }
        });
    }

    /*** Scroll to section  ***/
    (() =>{
        const getScrollToSection = localStorage.getItem('sectionScroll');

        if(getScrollToSection){
            const sectionToScroll = document.querySelector(`${getScrollToSection}`);

            /*** scroll to ***/
            let elTop = sectionToScroll.getBoundingClientRect().top;
            let offsetPosition = elTop - 120;

            window.scrollBy({
                top: offsetPosition,
                behavior: 'smooth'
            });

            /*** remove storage link ***/
            localStorage.removeItem('sectionScroll');
        }
    })();

    /********************************
     * Home page Drawer
     *******************************/
    (()=>{
        const triggerCart = document.querySelector('.toggle-card');
        const sidebarCart = document.querySelector('#sidebar-cart');

        triggerCart.addEventListener('click', () =>{
           if(!body.classList.contains('header-scroll') && body.getAttribute('data-route') === 'index'){
               sidebarCart.style.top = `0px`;
               sidebarCart.style.height = `100vh`;
           }else{
               sidebarCart.removeAttribute('style')
           }
        });
    })();

    /********************************
     * Search show or hide
     *******************************/
    (() =>{
        const triggerSearch = document.querySelector('#trigger-search');

        triggerSearch.addEventListener('click', () =>{
            if(body.classList.contains('show-menu')){
                body.classList.remove('show-menu');
            }

            body.classList.toggle('show-search');
        });

        mask.addEventListener('click', () => body.classList.remove('show-search'));

    })();

    /********************************
     * CART note
     *******************************/
    const cartSidebar = document.querySelector('#sidebar-cart');
    cartSidebar.addEventListener('click', ({target})=>{

        if(target.classList.contains('Drawer__Main_mask')){
            const cartNoteContainer = document.querySelector('.Cart__OffscreenNoteContainer');

            cartSidebar.classList.remove('has-note-open');
            cartNoteContainer.setAttribute('aria-hidden', 'true');
        }
    });

});